import { useState } from "react";


import { JobTitle } from "../molecule/jobTitle";
import { JobRow } from "../molecule/jobRowRule";

export default function JobTitleMatch({ruleTitle = "Functie titel matching", ruleDescription = "Hoe belangrijk is het dat de functie titel van een lead?", rolesData = [], updateRole}) {
    

    

    return (
        
        <JobTitle ruleTitle={ruleTitle} ruleDescription={ruleDescription} subCount={rolesData.length}>

            {rolesData.map((role, i) => (
                <JobRow
                    key={i}
                    title={role.title}
                    scoring={role.selected}
               
                    onToggle={() =>
                        updateRole(i)
                    }
                />
            ))}
        </JobTitle>
    );
}